module.exports = __webpack_public_path__ + "static/media/iconDecks.aad884b8.svg";